import { updateDoc, doc, getDoc } from "@firebase/firestore";
import { hideLoading, showLoading } from "./item-types-edit-slice";
import { showErrorSnackbar, showSuccessSnackbar } from "../../../shared/snackbar/snackbar-slice";
import { editTypes } from "../item-types-list/item-types-list-slice";

// export const getItemTypesDataService = async (dispatch, db, coll, id) => {
//     try {
//         const docRef = doc(db, coll, id);
//         const docSnap = await getDoc(docRef);
//         if (docSnap.exists()) {
//             return docSnap.data();
//         } else {
//             dispatch(showWarningSnackbar("This document no longer exists."));
//         }
//     } catch(e) {
//         console.error("ItemTypesEdit getItemTypesDataService error: ", e);
//     }
// };

export const editItemTypesService = async (dispatch, db, coll, id, formData) => {
    dispatch(showLoading());
    try {
        await updateDoc(doc(db, coll, id), formData);
        // Wait for the document to be updated
        await new Promise(resolve => setTimeout(resolve, 1000));
        const docSnap = await getDoc(doc(db, coll, id));
        const updatedData = docSnap.data();
        const data = {
            ...updatedData,
            id: id,
        };
        dispatch(editTypes(data));
        dispatch(showSuccessSnackbar('Updated successfully!'));
    } catch(e) {
        dispatch(showErrorSnackbar('Update failed! Please, try again.'));
        console.error("ItemTypesEdit editItemTypesService error: ", e);
    }
    dispatch(hideLoading());
};
